import { useEffect } from 'react';
import styles from "../styles.module.css";

const ColorComponent = ({ passData, returnClick, fenceMaterial}) => {

  const colorMap = {
    "Aluminum":    "Black",
    "Hollow Vinyl":"White",
    "Steel":       "Black",
    "Solid Vinyl": "White",
  };

  useEffect(() => {
    const autoColor = colorMap[fenceMaterial] ?? "Natural";
    passData(autoColor);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fenceMaterial]);

  return (
    <div style={{ paddingBottom: "80px" }}>
      <div id="fenceTypes">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingBottom: "30px" }}>
            <h1 style={{color: 'maroon'}}>Select Fence Color</h1>
            <div style={{ textAlign: "center", display: 'flex', justifyContent: 'flex-start' }}>
                <button className={styles.Button} onClick={() => returnClick("fenceColor")}>Return</button>
            </div>
        </div>
      </div>
    </div>
  );
}

export default ColorComponent;